<template>
  <div>
    <Breadcrumbs main="Помощь" title="Редактировать раздел помощи"></Breadcrumbs>
    <div class="container">
      <b-card>
        <b-tabs class="mt-3 d-flex justify-content-md-start justify-content-center flex-wrap">
          <b-tab v-for="lang in languages"
                 :title="lang.language"
                 :key="'lang-' + lang.id"
                 @click="getLanguageFromBtn(lang?.language?.toLowerCase())"
                 nav-class="mr-2 mb-2">
            <template #title>
              <div class="d-flex justify-content-center">
                <img :src="lang.img" width="20" height="20" class="mr-2">
                <span>{{ lang.language }}</span>
              </div>
            </template>
          </b-tab>
        </b-tabs>
        <pre>
        {{currentHelp}}
        </pre>
        <b-form>
          <label class="mt-3"><b>Заголовок {{ language.toUpperCase() }}</b></label>
          <b-form-input placeholder="Заголовок" v-model="currentHelp.title[language]"></b-form-input>
          <label class="mt-3"><b>Описание {{ language?.toUpperCase() }}</b></label>
          <template v-for="lang in languages">
            <SunEditor
                :key="lang.language + '-helpDescription'"
                v-if="lang.language.toLowerCase() === language"
                v-model="currentHelp.description[lang.language.toLowerCase()]"
                :editorId="'helpDescription'" />
          </template>

        </b-form>

        <label class="mt-3"><b>Дата</b></label>
        <DatePicker mode="dateTime" v-model="currentHelp.created_at" is24hr :model-config="modelConfig"
                    :popover="{ visibility: 'click' }">
          <template v-slot="{ inputValue, inputEvents }">
            <input type="text" class="form-control" :value="inputValue" v-on="inputEvents"/>
          </template>
        </DatePicker>

<!--        <label>Автор</label>-->
<!--        <b-form-input v-model="currentHelp.author.name" disabled></b-form-input>-->

        <b-btn variant="success" class="mt-5"
               @click.prevent="updateHelpDeskEdit({
                 id: currentHelp.id,
                 title: currentHelp.title,
                 description: currentHelp.description,
                 position: currentHelp.position,
                 created_at: currentHelp.created_at})">
          Сохранить
        </b-btn>
      </b-card>
    </div>
  </div>
</template>

<script>
import {DatePicker} from 'v-calendar';
import {HelpAdapterMixin} from "@/mixins/helpdesk/HelpAdapterMixin";
import SunEditor from "@/components/SunEditor.vue";
import {LanguageAdapterMixin} from "@/mixins/Language/LanguageAdapterMixin";

export default {
  name: 'HelpEdit',
  mixins: [HelpAdapterMixin, LanguageAdapterMixin],
  components: {SunEditor, DatePicker},
  data() {
    return {
      // формат совпадает с тем, что отправлялся раньше: YYYY-MM-DD HH:mm
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD HH:mm',
      },
    }
  },
}
</script>
